<template>
	<div @update:data="setData" :main="true" :suspend="true" class="pb-12 px-3">
		<div v-if="brand?.id" class="flex w-full justify-center">
			<div class="w-full max-w-8xl md2:space-y-10">
				<div class="w-full text-center text-ihh-midnight-gray text-5xl font-semibold tracking-wide mb-4">{{ brand.name }}</div>

				<div v-if="brand.description" class="space-y-6 mx-auto !max-w-5xl category-custom" v-safe-html="processedDescription" />

				<div class="my-4 md2:hidden"></div>

				<BrandSearch :brand="brand" />
			</div>
		</div>
	</div>
</template>

<script>
import BrandSearch from './ihh-items/brand-search.vue'

export default {
	components: { BrandSearch },
	inject: ['store'],
	computed: {
		brand() {
			let rid = this.$route.params.id
			if (rid === 'Bach') {
				return this.store.brands.find((b) => b.bcId === 1)
			}
			return this.store?.brands?.find((b) => [`/${rid}`, `/${rid}/`].includes(b?.customUrl?.url)) || {}
		},
		processedDescription() {
			if (!this.brand?.description) return ''

			// Replace BigCommerce placeholders in the description
			// This approach avoids DOM manipulation in the computed property
			let processed = this.brand.description

			// Replace all occurrences of the BigCommerce placeholder
			processed = processed.replace(/%%GLOBAL_ShopPathSSL%%\//g, '/categories/')

			return processed
		},
	},

	watch: {
		'brand.description': function (newDescription) {
			console.log('description changed:', newDescription)
		},
	},

	mounted() {
		console.log('route:', this.$route)
		console.log('brand:', this.brand)
	},
}
</script>

<style>
.category-custom {
	color: #736980;
}

.category-custom h1 {
	font-size: 2.5rem;
	font-weight: 600;
	margin-bottom: 1rem;
}

.category-custom h2 {
	font-size: 1.75rem;
	font-weight: 600;
	margin-bottom: 1rem;
}

.category-custom a {
	color: #e59789;
	text-decoration: underline;
}

.category-custom .form-input {
	width: 100%;
	padding: 10px;
	border: 1px solid #ccc;
	border-radius: 4px;
	font-size: 16px;
	box-shadow: none;
	outline: none;
	transition: border-color 0.3s ease-in-out;
}

.category-custom .form-input:focus {
	border-color: #888; /* Optional focus effect */
}

/* Add space below input field */
.category-custom .form-input + br + br {
	margin-bottom: 15px;
}

/* Style the button */
.category-custom .button {
	width: 100%;
	background-color: #e59789; /* Matches the button background */
	color: #453c50; /* Dark gray text */
	font-size: 18px;
	font-weight: 500;
	padding: 12px;
	border: none;
	border-radius: 8px;
	cursor: pointer;
	transition: background-color 0.3s ease-in-out;
}

.category-custom .button:hover {
	background-color: #ffbeb2; /* Slightly darker on hover */
}

.is-srOnly {
	position: absolute;
	width: 1px;
	height: 1px;
	padding: 0;
	margin: -1px;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
	border: 0;
}
</style>
